module.exports = __webpack_public_path__ + "assets/121f6aae651e97866ac2cc3307db078f.mp3";